<template>
  <div v-loading.fullscreen="loading" class="page-card">
    <div class="header-scroll">
      <div class="header">
        <el-input
          v-model="search"
          placeholder="Ism yoki PINFL bo'yicha qidirish"
          clearable
          class="header-control"
          @input="onSearch"
          @clear="onSearch"
        />

        <el-button
          class="header-button header-button--right"
          type="primary"
          @click="openCreateDialog"
        >
          Qo'shish
        </el-button>
      </div>
    </div>

    <el-table :data="managers" border height="calc(100vh - 270px)">
      <el-table-column type="index" :index="indexMethod" width="60" />
      <el-table-column prop="fullname" label="F.I.Sh" min-width="220" />
      <el-table-column prop="pinfl" label="PINFL" min-width="160" />
      <el-table-column label="Vazirlik" min-width="260">
        <template #default="scope">
          <el-tag v-if="scope.row.ministry" effect="light" type="primary" class="ministry-tag">
            {{ scope.row.ministry.title }}
          </el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="Kategoriyalar" min-width="240">
        <template #default="scope">
          <template v-if="scope.row.categories && scope.row.categories.length">
            <el-tag
              v-for="cat in scope.row.categories.slice(0, 2)"
              :key="cat.id"
              effect="light"
              type="info"
              class="category-tag"
            >
              {{ cat.title }}
            </el-tag>
            <el-tag
              v-if="scope.row.categories.length > 2"
              effect="plain"
              type="info"
              class="category-tag"
            >
              +{{ scope.row.categories.length - 2 }}
            </el-tag>
          </template>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="Asos hujjat" min-width="120">
        <template #default="scope">
          <a
            v-if="scope.row.basis_document"
            :href="fileBaseUrl + scope.row.basis_document"
            target="_blank"
            rel="noopener noreferrer"
            class="basis-download-link"
          >
            Yuklash
          </a>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="region_title" label="Viloyat" min-width="170" />
      <el-table-column prop="district_title" label="Tuman/Shahar" min-width="170" />
      <el-table-column prop="created_at" label="Yaratilgan vaqti" min-width="170">
        <template #default="scope">
          {{
            scope.row.created_at
              ? $moment(scope.row.created_at).format("DD-MM-YYYY / HH:mm")
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column label="Holat" min-width="120">
        <template #default="scope">
          <el-tag :type="statusTagType(scope.row.status)" effect="light">
            {{ statusLabel(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="200" label="Amallar" fixed="right" align="center">
        <template #default="scope">
          <div class="row-actions">
            <el-tooltip content="Ko'rish" placement="top" :hide-after="0">
              <el-button
                size="small"
                :icon="View"
                @click="openViewDialog(scope.row)"
              />
            </el-tooltip>
            <el-tooltip content="Tahrirlash" placement="top" :hide-after="0">
              <el-button
                size="small"
                type="primary"
                :icon="Edit"
                @click="openEditDialog(scope.row)"
              />
            </el-tooltip>
            <el-tooltip content="Hisobot (Excel)" placement="top" :hide-after="0">
              <el-button
                size="small"
                type="success"
                :icon="Download"
                @click="openReportDialog(scope.row)"
              />
            </el-tooltip>
            <el-popconfirm
              title="O'chirishni tasdiqlaysizmi?"
              confirm-button-text="Ha"
              cancel-button-text="Bekor qilish"
              confirm-button-type="danger"
              :icon="WarningFilled"
              icon-color="#f56c6c"
              :width="240"
              placement="top-end"
              :teleported="true"
              popper-class="delete-popconfirm"
              @confirm="onDelete(scope.row)"
            >
              <template #reference>
                <el-tooltip content="O'chirish" placement="top" :hide-after="0">
                  <el-button size="small" type="danger" :icon="Delete" />
                </el-tooltip>
              </template>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <div>Vazirlik menejerlari soni: {{ totalCount }}</div>
      <el-pagination
        background
        layout="sizes, prev, pager, next"
        :total="totalCount"
        v-model:page-size="limit"
        v-model:current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      v-model="showDialog"
      :title="form.id ? 'Vazirlik menejerini tahrirlash' : 'Vazirlik menejeri qo\'shish'"
      width="560px"
      @closed="resetForm"
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-position="top">
        <el-form-item label="F.I.Sh" prop="fullname">
          <el-input
            v-model="form.fullname"
            size="large"
            placeholder="Ism Familiya"
          />
        </el-form-item>

        <el-form-item label="PINFL" prop="pinfl">
          <el-input
            v-model="form.pinfl"
            size="large"
            maxlength="14"
            inputmode="numeric"
            :disabled="!!form.id"
            placeholder="14 ta raqam"
            @input="onPinflInput"
          />
          <div v-if="form.id" class="field-hint">PINFL o'zgartirib bo'lmaydi</div>
        </el-form-item>

        <el-form-item label="Vazirlik" prop="ministry_id">
          <el-select
            v-model="form.ministry_id"
            style="width: 100%"
            size="large"
            filterable
            placeholder="Vazirlikni tanlang"
            :loading="ministriesLoading"
          >
            <el-option
              v-for="ministry in ministries"
              :key="ministry.id"
              :value="ministry.id"
              :label="ministry.code ? `${ministry.title} (${ministry.code})` : ministry.title"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Viloyat" prop="region_id">
          <el-select
            v-model="form.region_id"
            style="width: 100%"
            size="large"
            placeholder="Viloyatni tanlang"
            :loading="regionsLoading"
            @change="onChangeRegion"
          >
            <el-option
              v-for="region in regions"
              :key="region.id"
              :value="region.id"
              :label="region.title"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Tuman/Shahar" prop="district_id">
          <el-select
            v-model="form.district_id"
            style="width: 100%"
            size="large"
            filterable
            placeholder="Tumanni tanlang"
            :loading="districtsLoading"
          >
            <el-option
              v-for="district in districts"
              :key="district.id"
              :value="district.id"
              :label="district.title"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Kategoriyalar" prop="category_ids">
          <el-select
            v-model="form.category_ids"
            style="width: 100%"
            size="large"
            multiple
            filterable
            collapse-tags
            collapse-tags-tooltip
            placeholder="Kategoriyalarni tanlang"
            :loading="categoriesLoading"
          >
            <el-option
              v-for="category in categories"
              :key="category.id"
              :value="category.id"
              :label="category.title"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Asos hujjat (PDF)" prop="basis_document" class="basis-form-item">
          <el-upload
            ref="upload"
            class="basis-file-upload"
            v-model:file-list="fileList"
            :on-change="handleFileChange"
            :on-remove="handleFileRemove"
            :on-exceed="handleFileExceed"
            :auto-upload="false"
            :show-file-list="true"
            accept=".pdf,application/pdf"
            :limit="1"
          >
            <el-button size="small" type="primary" :loading="fileUploading">
              Fayl tanlang
            </el-button>
          </el-upload>
          <div v-if="form.basis_document" class="basis-current">
            <a
              :href="fileBaseUrl + form.basis_document"
              target="_blank"
              rel="noopener noreferrer"
              class="basis-download-link"
            >
              Joriy hujjatni ko'rish
            </a>
          </div>
          <div class="field-hint">Faqat PDF, majburiy</div>
        </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showDialog = false">Bekor qilish</el-button>
          <el-button type="primary" :loading="saving" @click="onSubmit">
            Saqlash
          </el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog
      v-model="showViewDialog"
      width="600px"
      align-center
      class="mm-view-dialog"
      :show-close="false"
    >
      <template #header>
        <div class="mm-dialog-header">
          <span>Vazirlik menejeri</span>
          <el-button link class="mm-dialog-close" @click="showViewDialog = false">
            <el-icon :size="18"><Close /></el-icon>
          </el-button>
        </div>
      </template>

      <div v-if="viewItem" class="mm-detail">
        <div class="mm-hero">
          <div class="mm-avatar">{{ initials(viewItem.fullname) }}</div>
          <div class="mm-hero-main">
            <div class="mm-hero-name">{{ viewItem.fullname || "-" }}</div>
            <div class="mm-hero-sub">
              <el-icon><OfficeBuilding /></el-icon>
              <span>{{ viewItem.ministry ? viewItem.ministry.title : "—" }}</span>
            </div>
          </div>
          <el-tag
            :type="statusTagType(viewItem.status)"
            effect="light"
            round
            class="mm-status"
          >
            {{ statusLabel(viewItem.status) }}
          </el-tag>
        </div>

        <div class="mm-card">
          <div class="mm-row">
            <span class="mm-row-label">PINFL</span>
            <div class="mm-row-value">
              <span class="mm-mono">{{ viewItem.pinfl || "-" }}</span>
              <el-button
                v-if="viewItem.pinfl"
                link
                class="mm-copy"
                @click="copyValue(viewItem.pinfl)"
              >
                <el-icon><CopyDocument /></el-icon>
              </el-button>
            </div>
          </div>
          <div class="mm-row">
            <span class="mm-row-label">Login</span>
            <div class="mm-row-value">
              <span class="mm-mono">{{ viewItem.username || "-" }}</span>
              <el-button
                v-if="viewItem.username"
                link
                class="mm-copy"
                @click="copyValue(viewItem.username)"
              >
                <el-icon><CopyDocument /></el-icon>
              </el-button>
            </div>
          </div>
        </div>

        <div class="mm-block">
          <div class="mm-block-head">
            <span>Kategoriyalar</span>
            <span v-if="viewItem.categories && viewItem.categories.length" class="mm-count">
              {{ viewItem.categories.length }}
            </span>
          </div>
          <div
            v-if="viewItem.categories && viewItem.categories.length"
            class="mm-chips"
          >
            <span
              v-for="cat in viewItem.categories"
              :key="cat.id"
              class="mm-chip"
              :title="cat.title"
            >
              {{ cat.title }}
            </span>
          </div>
          <div v-else class="mm-empty">—</div>
        </div>

        <div class="mm-block">
          <div class="mm-block-head"><span>Asos hujjat</span></div>
          <a
            v-if="viewItem.basis_document"
            :href="fileBaseUrl + viewItem.basis_document"
            target="_blank"
            rel="noopener noreferrer"
            class="mm-doc-card"
          >
            <div class="mm-doc-icon"><el-icon :size="20"><Document /></el-icon></div>
            <div class="mm-doc-text">
              <div class="mm-doc-title">Asos hujjat (PDF)</div>
              <div class="mm-doc-sub">Ko'rish / yuklab olish</div>
            </div>
          </a>
          <div v-else class="mm-empty">—</div>
        </div>

        <div class="mm-meta">
          <el-icon><Calendar /></el-icon>
          <span>
            Yaratilgan:
            {{
              viewItem.created_at
                ? $moment(viewItem.created_at).format("DD-MM-YYYY / HH:mm")
                : "-"
            }}
          </span>
        </div>
      </div>

      <template #footer>
        <el-button @click="showViewDialog = false">Yopish</el-button>
        <el-button type="primary" @click="editFromView">Tahrirlash</el-button>
      </template>
    </el-dialog>

    <el-dialog
      v-model="showReportDialog"
      title="Hisobot (Excel)"
      width="440px"
      @closed="reportBoardId = null"
    >
      <div v-if="reportManager" class="report-manager">
        <span class="report-manager-label">Menejer</span>
        <span class="report-manager-name">{{ reportManager.fullname }}</span>
      </div>
      <el-form label-position="top">
        <el-form-item label="Mavsum (kengash)">
          <el-select
            v-model="reportBoardId"
            style="width: 100%"
            size="large"
            filterable
            placeholder="Mavsumni tanlang"
            :loading="boardsLoading"
          >
            <el-option
              v-for="board in boards"
              :key="board.id"
              :value="board.id"
              :label="boardLabel(board)"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showReportDialog = false">Bekor qilish</el-button>
        <el-button
          type="primary"
          :icon="Download"
          :loading="reportDownloading"
          :disabled="!reportBoardId"
          @click="downloadReport"
        >
          Yuklab olish
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage, ElNotification } from "element-plus";
import {
  WarningFilled,
  OfficeBuilding,
  Document,
  CopyDocument,
  Calendar,
  Close,
  View,
  Edit,
  Delete,
  Download,
} from "@element-plus/icons-vue";
import { blobErrorMessage } from "@/utils/common";

export default {
  name: "MinistryManagerList",
  components: {
    OfficeBuilding,
    Document,
    CopyDocument,
    Calendar,
    Close,
  },
  data() {
    const validatePinfl = (rule, value, callback) => {
      if (!value) {
        callback(new Error("Majburiy maydon"));
        return;
      }
      if (!/^\d{14}$/.test(value)) {
        callback(new Error("PINFL 14 ta raqamdan iborat bo'lishi kerak"));
        return;
      }
      callback();
    };

    const validateBasisDocument = (rule, value, callback) => {
      if (this.fileUploading) {
        callback(new Error("PDF fayl yuklanmoqda, biroz kuting"));
        return;
      }
      if (!this.form.basis_document) {
        callback(new Error("Asos hujjatni (PDF) yuklang"));
        return;
      }
      callback();
    };

    return {
      WarningFilled,
      View,
      Edit,
      Delete,
      Download,
      fileBaseUrl: process.env.VUE_APP_BASE_API_URL + "api/v2/info/file/",
      loading: false,
      saving: false,
      regionsLoading: false,
      districtsLoading: false,
      ministriesLoading: false,
      categoriesLoading: false,
      fileUploading: false,
      managers: [],
      totalCount: 0,
      limit: 20,
      currentPage: 1,
      search: "",
      searchTimer: null,
      regions: [],
      districts: [],
      ministries: [],
      categories: [],
      fileList: [],
      showDialog: false,
      showViewDialog: false,
      viewItem: null,
      boards: [],
      boardsLoading: false,
      showReportDialog: false,
      reportManager: null,
      reportBoardId: null,
      reportDownloading: false,
      form: {
        id: null,
        fullname: "",
        pinfl: "",
        region_id: null,
        district_id: null,
        ministry_id: null,
        category_ids: [],
        basis_document: null,
        file: null,
      },
      rules: {
        fullname: [{ required: true, message: "Majburiy maydon", trigger: "blur" }],
        pinfl: [{ validator: validatePinfl, trigger: "blur" }],
        ministry_id: [{ required: true, message: "Majburiy maydon", trigger: "change" }],
        region_id: [{ required: true, message: "Majburiy maydon", trigger: "change" }],
        district_id: [{ required: true, message: "Majburiy maydon", trigger: "change" }],
        category_ids: [
          {
            type: "array",
            required: true,
            min: 1,
            message: "Kamida bitta kategoriyani tanlang",
            trigger: "change",
          },
        ],
        basis_document: [{ validator: validateBasisDocument, trigger: "change" }],
      },
    };
  },
  methods: {
    statusLabel(status) {
      const map = { 1: "Faol", 2: "Nofaol" };
      return map[status] || "Nofaol";
    },
    statusTagType(status) {
      return status === 1 ? "success" : "info";
    },
    indexMethod(index) {
      return this.limit * (this.currentPage - 1) + index + 1;
    },
    getManagers() {
      this.loading = true;
      this.$http
        .get("/api/v1/ministry-managers", {
          params: {
            search: this.search || null,
            limit: this.limit,
            offset: this.limit * (this.currentPage - 1),
          },
        })
        .then(({ data }) => {
          this.managers = data.items || [];
          this.totalCount = data.count || 0;
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response?.data?.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.currentPage = 1;
        this.getManagers();
      }, 400);
    },
    getMinistries() {
      this.ministriesLoading = true;
      this.$http
        .get("/api/v1/ministries", { params: { limit: 1000 } })
        .then(({ data }) => {
          this.ministries = data.data || [];
        })
        .catch(() => {})
        .finally(() => {
          this.ministriesLoading = false;
        });
    },
    getCategories() {
      this.categoriesLoading = true;
      this.$http
        .get("/api/v1/initiative-categories", {
          params: { is_active: 1, limit: 1000 },
        })
        .then(({ data }) => {
          this.categories = data.initiative_categories || [];
        })
        .catch(() => {})
        .finally(() => {
          this.categoriesLoading = false;
        });
    },
    isPdfFile(file) {
      if (!file) return false;
      const fileName = String(file.name || "").toLowerCase();
      return file.type === "application/pdf" || fileName.endsWith(".pdf");
    },
    createLocalFileItem(file) {
      return {
        name: file.name,
        percentage: 0,
        raw: file,
        size: file.size,
        status: "success",
        uid: file.uid || Date.now(),
      };
    },
    resetFileSelection() {
      this.form.file = null;
      this.form.basis_document = null;
      this.fileList = [];
      this.$refs.upload?.clearFiles();
      this.$nextTick(() => {
        this.$refs.formRef?.validateField("basis_document", () => {});
      });
    },
    uploadPdfFile(file) {
      const formData = new FormData();
      formData.append("file", file);
      this.fileUploading = true;
      return this.$http
        .post("api/v2/info/file/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(({ data }) => {
          this.form.basis_document = data.hashId;
        })
        .catch(({ response }) => {
          this.resetFileSelection();
          ElNotification({
            title: "Xatolik",
            message:
              response?.data?.message || "PDF faylni yuklashda xatolik sodir bo'ldi",
            type: "error",
          });
        })
        .finally(() => {
          this.fileUploading = false;
          this.$nextTick(() => {
            this.$refs.formRef?.validateField("basis_document", () => {});
          });
        });
    },
    processSelectedFile(rawFile) {
      if (!this.isPdfFile(rawFile)) {
        ElNotification({
          title: "Xatolik",
          message: "Faqat PDF fayllar ruxsat etiladi",
          type: "error",
        });
        this.resetFileSelection();
        return;
      }
      this.form.file = rawFile;
      this.form.basis_document = null;
      this.fileList = [this.createLocalFileItem(rawFile)];
      this.uploadPdfFile(rawFile);
    },
    handleFileChange(file) {
      if (!file?.raw) return;
      this.processSelectedFile(file.raw);
    },
    handleFileRemove() {
      this.form.file = null;
      this.form.basis_document = null;
      this.fileList = [];
      this.$nextTick(() => {
        this.$refs.formRef?.validateField("basis_document", () => {});
      });
    },
    handleFileExceed(files) {
      const rawFile = files?.[0];
      if (!rawFile) return;
      this.fileList = [];
      this.$refs.upload?.clearFiles();
      this.processSelectedFile(rawFile);
    },
    getRegions() {
      this.regionsLoading = true;
      this.$http
        .get("/api/v1/regions")
        .then(({ data }) => {
          this.regions = data.regions || [];
        })
        .catch(() => {})
        .finally(() => {
          this.regionsLoading = false;
        });
    },
    getDistricts(regionId) {
      if (!regionId) {
        this.districts = [];
        return;
      }
      this.districtsLoading = true;
      this.$http
        .get("/api/v1/districts", { params: { region_id: regionId } })
        .then(({ data }) => {
          this.districts = data.districts || [];
        })
        .catch(() => {})
        .finally(() => {
          this.districtsLoading = false;
        });
    },
    onChangeRegion() {
      this.form.district_id = null;
      this.districts = [];
      this.getDistricts(this.form.region_id);
    },
    onPinflInput(value) {
      this.form.pinfl = String(value || "")
        .replace(/\D/g, "")
        .slice(0, 14);
    },
    initials(name) {
      const parts = String(name || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean);
      if (!parts.length) return "?";
      const letters = parts.slice(0, 2).map((p) => p[0].toUpperCase());
      return letters.join("");
    },
    openViewDialog(row) {
      this.viewItem = row;
      this.showViewDialog = true;
    },
    editFromView() {
      const row = this.viewItem;
      this.showViewDialog = false;
      this.openEditDialog(row);
    },
    copyValue(value) {
      const text = String(value ?? "");
      const done = () => ElMessage({ type: "success", message: "Nusxa olindi" });
      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(() => {});
        return;
      }
      const ta = document.createElement("textarea");
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
        done();
      } catch (e) {
        // ignore
      }
      document.body.removeChild(ta);
    },
    openCreateDialog() {
      this.resetForm();
      if (!this.regions.length) this.getRegions();
      if (!this.ministries.length) this.getMinistries();
      if (!this.categories.length) this.getCategories();
      this.showDialog = true;
    },
    openEditDialog(row) {
      if (!this.regions.length) this.getRegions();
      if (!this.ministries.length) this.getMinistries();
      if (!this.categories.length) this.getCategories();
      this.fileList = [];
      this.form = {
        id: row.id,
        fullname: row.fullname || "",
        pinfl: row.pinfl || "",
        region_id: row.region_id ?? null,
        district_id: row.district_id ?? null,
        ministry_id: row.ministry ? row.ministry.id : null,
        category_ids: (row.categories || []).map((c) => c.id),
        basis_document: row.basis_document || null,
        file: null,
      };
      this.getDistricts(this.form.region_id);
      this.showDialog = true;
    },
    resetForm() {
      this.form = {
        id: null,
        fullname: "",
        pinfl: "",
        region_id: null,
        district_id: null,
        ministry_id: null,
        category_ids: [],
        basis_document: null,
        file: null,
      };
      this.districts = [];
      this.fileList = [];
      this.$refs.upload?.clearFiles();
      this.$refs.formRef?.clearValidate();
    },
    onSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.saveManager();
      });
    },
    saveManager() {
      this.saving = true;
      // region_id is intentionally NOT sent — the backend derives it from
      // district_id. PINFL is immutable, so it is omitted on update (PUT).
      let payload;
      let request;
      if (this.form.id) {
        // PUT is a full replace — all fields required (incl. basis_document &
        // category_ids). If no new PDF was uploaded, the current basis_document
        // id is re-sent unchanged. PINFL is immutable, so it is omitted.
        payload = {
          fullname: this.form.fullname.trim(),
          district_id: this.form.district_id,
          ministry_id: this.form.ministry_id,
          basis_document: this.form.basis_document,
          category_ids: this.form.category_ids,
        };
        request = this.$http.put(`/api/v1/ministry-managers/${this.form.id}`, payload);
      } else {
        payload = {
          fullname: this.form.fullname.trim(),
          pinfl: String(this.form.pinfl),
          district_id: this.form.district_id,
          ministry_id: this.form.ministry_id,
          basis_document: this.form.basis_document,
          category_ids: this.form.category_ids,
        };
        request = this.$http.post("/api/v1/ministry-managers", payload);
      }

      request
        .then(() => {
          ElNotification({
            title: "Tabriklaymiz",
            message: "Muvaffaqiyatli saqlandi",
            type: "success",
          });
          this.showDialog = false;
          this.getManagers();
        })
        .catch(({ response }) => {
          ElNotification({
            title: "Xatolik",
            message: response?.data?.message || "Iltimos, qayta urinib ko'ring.",
            type: "error",
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    onDelete(row) {
      this.loading = true;
      this.$http
        .delete(`/api/v1/ministry-managers/${row.id}`)
        .then(() => {
          ElMessage({ type: "success", message: "Vazirlik menejeri o'chirildi" });
          if (this.managers.length === 1 && this.currentPage > 1) {
            this.currentPage -= 1;
          }
          this.getManagers();
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response?.data?.message || "Iltimos, qayta urinib ko'ring",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange() {
      this.getManagers();
    },
    handleSizeChange() {
      this.currentPage = 1;
      this.getManagers();
    },
    boardLabel(board) {
      const season = board.season ? `${board.season}-mavsum` : "";
      const year = board.year ? `${board.year} yil` : "";
      return [board.title, season, year].filter(Boolean).join(" ");
    },
    getBoards() {
      this.boardsLoading = true;
      this.$http
        .get("api/v1/boards", { params: { status: 1 } })
        .then(({ data }) => {
          this.boards = data.boards || [];
        })
        .catch(() => {})
        .finally(() => {
          this.boardsLoading = false;
        });
    },
    openReportDialog(row) {
      this.reportManager = row;
      this.reportBoardId = null;
      if (!this.boards.length) this.getBoards();
      this.showReportDialog = true;
    },
    downloadReport() {
      if (!this.reportBoardId || !this.reportManager) return;
      this.reportDownloading = true;
      // Admin downloads a specific manager's report → pass manager_id (their UUID).
      // Response is a binary .xlsx blob, not JSON.
      this.$http
        .get("api/v1/ministry-manager/products-report", {
          params: {
            board_id: this.reportBoardId,
            manager_id: this.reportManager.id,
          },
          responseType: "blob",
        })
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            })
          );
          let fileName = `Products-report-${this.$moment().format("YYYY-MM-DD")}.xlsx`;
          const headers = res.headers || {};
          const header =
            (headers.get && headers.get("Content-Disposition")) ||
            headers["content-disposition"];
          if (header) {
            const match = header.match(/filename[^;=\n]*=["']?([^";'\n]+)["']?/i);
            if (match && match[1]) fileName = decodeURIComponent(match[1].trim());
          }
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
          ElMessage({ type: "success", message: "Hisobot yuklab olindi" });
          this.showReportDialog = false;
        })
        .catch(async ({ response }) => {
          const msg = await blobErrorMessage(
            response,
            "Hisobotni yuklashda xatolik sodir bo'ldi"
          );
          ElNotification({ type: "error", title: "Xatolik", message: msg });
        })
        .finally(() => {
          this.reportDownloading = false;
        });
    },
  },
  mounted() {
    this.getManagers();
  },
};
</script>

<style scoped>
.page-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 18px;
  box-shadow: 0 6px 24px rgba(17, 24, 39, 0.08), 0 1px 3px rgba(17, 24, 39, 0.06);
}

.header-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: 10px;
}

.header {
  display: flex;
  gap: 10px;
  align-items: center;
}

.header-control {
  width: 320px;
  flex-shrink: 0;
}

.header-button {
  flex-shrink: 0;
}

.header-button--right {
  margin-left: auto;
}

.row-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.row-actions :deep(.el-button + .el-button) {
  margin-left: 0;
}

.field-hint {
  display: block;
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
  margin-top: 6px;
}

.report-manager {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 14px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #f4f6f8;
}

.report-manager-label {
  font-size: 12px;
  color: #6b7280;
}

.report-manager-name {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
}

.page-card :deep(.el-table) {
  border-radius: 10px;
  overflow: hidden;
}

.page-card :deep(.ministry-tag) {
  height: auto;
  max-width: 100%;
  white-space: normal;
  line-height: 1.4;
  padding: 4px 8px;
}

.page-card :deep(.category-tag) {
  height: auto;
  max-width: 100%;
  white-space: normal;
  line-height: 1.4;
  padding: 3px 8px;
  margin: 2px 4px 2px 0;
}

.basis-download-link {
  color: var(--el-color-primary);
  text-decoration: none;
  font-weight: 500;
}

.basis-download-link:hover {
  text-decoration: underline;
}

.basis-form-item :deep(.el-form-item__content) {
  display: block;
}

.basis-current {
  margin-top: 8px;
}

.basis-file-upload {
  width: 100%;
}

/* ---- Detail / View dialog ---- */
.mm-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

.mm-dialog-close {
  color: #9ca3af;
  padding: 4px;
}

.mm-dialog-close:hover {
  color: #4b5563;
}

.mm-detail {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Hero */
.mm-hero {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  border-radius: 14px;
  background: linear-gradient(135deg, #eef2ff 0%, #f5f3ff 100%);
  border: 1px solid #e5e7eb;
}

.mm-avatar {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: var(--el-color-primary);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.mm-hero-main {
  flex: 1;
  min-width: 0;
}

.mm-hero-name {
  font-size: 17px;
  font-weight: 600;
  color: #111827;
  line-height: 1.3;
  word-break: break-word;
}

.mm-hero-sub {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-size: 13px;
  color: #6b7280;
}

.mm-hero-sub .el-icon {
  flex-shrink: 0;
}

.mm-status {
  flex-shrink: 0;
  align-self: flex-start;
  font-weight: 500;
}

/* Identity card */
.mm-card {
  border: 1px solid #eceef1;
  border-radius: 12px;
  overflow: hidden;
}

.mm-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
}

.mm-row + .mm-row {
  border-top: 1px solid #f0f2f5;
}

.mm-row-label {
  font-size: 13px;
  color: #6b7280;
}

.mm-row-value {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.mm-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 14px;
  color: #1f2937;
}

.mm-copy {
  color: #9ca3af;
  padding: 2px;
}

.mm-copy:hover {
  color: var(--el-color-primary);
}

/* Blocks */
.mm-block-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #9ca3af;
}

.mm-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: #eef2ff;
  color: var(--el-color-primary);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
}

.mm-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 190px;
  overflow-y: auto;
  padding-right: 4px;
}

.mm-chip {
  display: inline-block;
  max-width: 100%;
  padding: 5px 12px;
  border-radius: 8px;
  background: #f4f6f8;
  border: 1px solid #eceef1;
  color: #374151;
  font-size: 13px;
  line-height: 1.4;
}

.mm-chips::-webkit-scrollbar {
  width: 6px;
}

.mm-chips::-webkit-scrollbar-thumb {
  background: #d8dce1;
  border-radius: 3px;
}

/* Document card */
.mm-doc-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #eceef1;
  border-radius: 12px;
  text-decoration: none;
  transition: border-color 0.15s, background 0.15s;
}

.mm-doc-card:hover {
  border-color: var(--el-color-primary);
  background: #fafbff;
}

.mm-doc-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fef2f2;
  color: #ef4444;
}

.mm-doc-title {
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
}

.mm-doc-sub {
  font-size: 12px;
  color: var(--el-color-primary);
}

.mm-empty {
  color: #9ca3af;
  font-size: 14px;
}

.mm-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #9ca3af;
}
</style>

<style>
.mm-view-dialog .el-dialog__header {
  margin-right: 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f2f5;
}

.mm-view-dialog .el-dialog__body {
  max-height: 62vh;
  overflow-y: auto;
  padding-top: 16px;
}

.delete-popconfirm {
  padding: 10px !important;
  border-radius: 6px !important;
  border: 1px solid #ebeef5 !important;
  box-shadow: 0 16px 48px rgba(17, 24, 39, 0.28), 0 4px 12px rgba(17, 24, 39, 0.16) !important;
  z-index: 3000 !important;
}

.delete-popconfirm .el-popper__arrow::before {
  border: 1px solid #ebeef5 !important;
}

.delete-popconfirm .el-popconfirm__main {
  align-items: center;
  margin-bottom: 14px;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.delete-popconfirm .el-popconfirm__icon {
  font-size: 18px;
}

.delete-popconfirm .el-popconfirm__action {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
</style>
